{
  "version": 1,
  "asset_id": "dc62252e-02a1-4e06-a47c-9f794cff7cd7",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dc62252e-02a1-4e06-a47c-9f794cff7cd7/ind-healthcare-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dc62252e-02a1-4e06-a47c-9f794cff7cd7/ind-healthcare-1200.webp",
  "original_filename": "ind-healthcare-1200.webp",
  "size": 11050,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:01Z"
}
